import React, { useState } from 'react';
import { connect } from 'react-redux';
import { TitleWithButton } from './utils';
import CustomerEdit from '../../assets/images/customer_edit.svg';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import './MembershipSection.scss';
import EditMembershipModal from './EditMembershipModal';
import { PermissionCodes } from 'config/PermissionCodes';
import ResetPasswordModal from './ResetPasswordModal';
import { CUSTOMER_REFERRER_METHOD } from 'config/CustomEnums';


const MembershipSection = ({
  customer,
}) => {
  const [showEditMembership, setShowEditMembership] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const displayReferralSource = () => {
    const referralMethod = customer?.referralMethod
    if (referralMethod === CUSTOMER_REFERRER_METHOD.REFERRAL_CODE) {
      return <>
        {customer.referralSource?.referrer ? <>
          <label className="customer-detail-membership-section-label">
            {`Member: ${customer.referralSource?.referrer || '-'}`}
          </label>
          <label className="customer-detail-membership-section-label">
            {`Referral campaign: ${customer.referralSource?.referredCampaigns?.length === 1
              ? customer.referralSource?.referredCampaigns[0] : ""}`}
          </label>
          {
            customer.referralSource?.referredCampaigns?.length > 1
              ? <ul className='customer-detail-membership-section-ul'>
                {
                  customer.referralSource?.referredCampaigns.map(campaign => (
                    <li>{campaign}</li>
                  ))
                }
              </ul>
              : null
          }
        </> : "-"
        }
      </> 
    }
    if (referralMethod === CUSTOMER_REFERRER_METHOD.PROMOTION_CODE) {
      return <>
        {customer.referralSource?.promotionCode ?
          <>
            <label className="customer-detail-membership-section-label">
              {`Promotion code: ${customer.referralSource?.promotionCode || '-'}`}
            </label>
            <label className="customer-detail-membership-section-label">
              {`Referral earning rule: ${customer.referralSource?.referralEarningRules?.length > 0
                ? "" : "-"}`}
            </label>
            {
              customer.referralSource?.referralEarningRules?.length > 0
                ? <ul className='customer-detail-membership-section-ul'>
                  {
                    customer.referralSource?.referralEarningRules.map(earningRule => (
                      <li>{earningRule?.displayEarningRule || "-"}</li>
                    ))
                  }
                </ul>
                : null
            }
          </>: "-"}
      </>
    }
    return (
      <label className="customer-detail-membership-section-label">
        {'-'}
      </label>
    )
  }

  const fields = [
    [
      { title: "Sign up from", field: 'displaySignUpChannel' },
    ],
    [
      {
        title: "Referral source (from referral code or promotion code)",
        customRender: displayReferralSource()
      },
    ],
    [
      { title: "Merchant admin for quick sign up", field: 'signUpByMerchant' },
    ],
  ];


  return (
    <>
      <TitleWithButton
        containerExtraClassName="customer-detail-section-title-container"
        title="MEMBERSHIP"
        titleExtraClassName="customer-detail-section-title"
        firstButtonContent={customer.isActivated && "Reset password"}
        firstButtonOnClick={() => setShowResetPasswordModal(true)}
        firstButtonRequires={PermissionCodes.changeCustomer}
        secondButtonImage={CustomerEdit}
        secondButtonContent={!customer.isDeleted && "Edit"}
        secondButtonOnClick={() => setShowEditMembership(true)}
        secondButtonRequires={PermissionCodes.changeCustomer}
      />

      <MembershipInfoCard
        title=""
        data={customer}
        fields={fields}
      />

      <EditMembershipModal
        show={showEditMembership}
        setShow={setShowEditMembership}
      />
      <ResetPasswordModal
        show={showResetPasswordModal}
        setShow={setShowResetPasswordModal}
      />
    </>
  )
}

const mapPropsToState = (state) => ({
  customer: state.customerList.customer,

});

export default connect(mapPropsToState)(MembershipSection);